var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error !== null)?_c('h1',{staticClass:"text-center"},[_vm._v(" Invalid Credentials... redirecting to dashboard in "+_vm._s(_vm.counter)+" seconds ")]):_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.statusText))])}
var staticRenderFns = []

export { render, staticRenderFns }